import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import Header from '../template/header'
import Footer from '../template/footer'
import About from './about'
import ValidateDoc from './validate-doc'
import Instructions from './instructions'
import FAQ from './faq'
import FAQService from '../../service/faq-service'

import './home.css'

import { Accordion, Button, Card, Container, Row, Col } from 'react-bootstrap';

import SmoothScroll from 'smooth-scroll';
import {ModalAlert} from '../template/modal-alert';

import i18n from "../../i18n";

import euEN from "../../../img/en_horizontal_cef_logo_2.png";
import euHR from "../../../img/hr_horizontal_cef_logo.png";

export default class Home extends Component {

	constructor(props) {
		super(props);

		var tLang = 2;
		document.getElementsByTagName("html")[0].setAttribute("lang", "en")
		if (i18n.language == "hr") {
			document.getElementsByTagName("html")[0].setAttribute("lang", "hr")
			tLang = 1;
		}

		this.state = {
			faqs: [],
			language: tLang
		};

		FAQService.getFaqs(tLang).then(response => {
			this.setState({
				faqs: response.data.cestaPitanja
			});
		}).catch(error => {
			ModalAlert(error.response.data.error.errorMsg, i18n.t("modal:greska"), i18n.t("modal:zatvori"));
		});
	}

	componentDidMount() {
		var scroll = new SmoothScroll('a[href*="#"]', {
			offset: 50
		});
		if ((window.location.hash != null) && (window.location.hash != "")) {
			var anchor = document.querySelector(window.location.hash);
			scroll.animateScroll(anchor);
		}
	}

	render() {
		return (
			<React.Fragment>
				<Header />
					<Container fluid>



						<section id="intro">
							<Row className="justify-content-center">
								<div className="landing-text">
									<h1 className="title">FINA Validator</h1>
									{/* <h1 className="title text-center">Validation</h1> */}
								</div>
							</Row>
							<Row className="justify-content-center">
								<Button data-scroll href={document.getElementById("endpoint").getAttribute("value") + "#about"} className="landing-btn" style={{ backgroundColor: "#3f5c94", paddingLeft: "25px", paddingRight: "25px", marginTop: "25px" }}>
									<Row className="justify-content-center text-center">{i18n.t("home:learn_more")}</Row>
								</Button>
							</Row>
							<br /><br />
						</section>

						<section id="about">
							<br /><br />
							<Container>
								<Row>
									<Col>
										<h2>{i18n.t("home:about")}</h2>
									</Col>
								</Row>
								<br />
								<About />
							</Container>
							<br /><br />
						</section>

						<main id="validate">
							<br /><br />
							<Container>
								<Row>
									<Col>
										<h2>{i18n.t("home:fina_validator")}</h2>
									</Col>
								</Row>
								<br />
								<ValidateDoc />
							</Container>
							<br /><br />
						</main>

						<section id="guide">
							<br /><br />
							<Container>
								<Row>
									<Col>
										<h2>{i18n.t("home:user_guide")}</h2>
									</Col>
								</Row>
								<br /><br />
								<Instructions language={this.state.language} />
							</Container>
						</section>

						<section id="faq">
							<br /><br />
							<Container>
								<Row>
									<Col>
										<h2>{i18n.t("home:faq")}</h2>
									</Col>
								</Row>
								<br />
								<Accordion>
									{this.state.faqs.length > 0 ?
										<React.Fragment>
											{this.state.faqs.map((faq, i) =>
												<FAQ question={faq.pitanje} answer={faq.odgovor} index={i} key={i} />
											)}
										</React.Fragment>
										:
										<p>Coming soon...</p>
									}
								</Accordion>
							</Container>
							<br /><br />
						</section>

						<br />
						<section id="eu">
							<Container>
								{i18n.language.toUpperCase() == "HR" ?
									<img className="cef" src={euHR} alt="Sufinancirano instrumentom Europske unije za povezivanje Europe" ></img>
									:
									<img className="cef" src={euEN} alt="Co-financed by the Connecting Europe Facility of the European Union"></img>
								}
							</Container>
						</section>
					</Container>
				<br className="visible-br-lg" />
				<br className="visible-br-md" />
				<br className="visible-br-sm" />
				<br className="visible-br-xs" />
				<Footer />
				<div id="iFrameParent"></div>
			</React.Fragment>
		)
	}

}




/*export default class Home extends Component {


	render() {
		return (
			<div style={{"scrollBehavior" : "smooth"}}>
				<Header />

				<About />
				<br />
				<ValidateDoc />

				<Footer />
			</div>
		);
	}
}*/